import { DeleteOutlineRounded } from "@mui/icons-material";
import { Button } from "@mui/material";

export default function ClearLocalStorageButton() {
  const handleClearLocalStorage = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <Button
      variant="outlined"
      startIcon={<DeleteOutlineRounded />}
      onClick={handleClearLocalStorage}
    >
      Clear Local Storage & Reload
    </Button>
  );
}
